import PropTypes from 'prop-types';
import React from 'react';
import * as styles from './styles/styles.module.scss';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { wrapEventHandler } from '../../../../utils/handlers';
import { getPhotoUrl } from '../../../../utils/photo_helper';

const PhotoPopup = ({ handleClick, imageSize, photo }) => {
  const title = photo.title ? photo.title : '';
  let fallbackPhotoUrl;
  let photoUrl = `/api/alltrails/photos/${photo.id}/image?size=${imageSize}&api_key=${ServerCommunicationUtil.apiKey}`;
  if (photo.photoHash) {
    fallbackPhotoUrl = photoUrl;
    photoUrl = getPhotoUrl(photo.id, photo.photoHash, imageSize);
  }
  let addFallbackSrc;
  if (fallbackPhotoUrl) {
    let shouldFallback = true;
    addFallbackSrc = ev => {
      if (shouldFallback) {
        ev.target.src = fallbackPhotoUrl;
        ev.target.onerror = null;
      }
      shouldFallback = false;
    };
  }
  return (
    <div key={photo} className={styles.photoPopup} onClick={wrapEventHandler(handleClick)}>
      <img alt={title} title={title} src={photoUrl} onError={addFallbackSrc} />
    </div>
  );
};

PhotoPopup.defaultProps = {
  handleClick: null,
  imageSize: 'medium_square'
};

PhotoPopup.propTypes = {
  handleClick: PropTypes.func,
  imageSize: PropTypes.string,
  photo: PropTypes.object.isRequired
};

export default PhotoPopup;
